import React, { useState, useEffect } from 'react';
import { Spin, message, Table } from 'antd';
import { categorizacion_vial, red_terciaria } from '../../../services/perfiles/conponentesServices';
import './tablaG.css';

const CategoriaVial = ({ municipioId }) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]); // Datos de categorización vial
    const [redData, setRedData] = useState([]); // Datos de red terciaria
    const [description, setDescription] = useState('');
    const [componente, setComponente] = useState('');
    const [fuente, setFuente] = useState('');

    useEffect(() => {
        if (municipioId) {
            fetchData();
            redterciaria();
        }

    }, [municipioId]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await categorizacion_vial(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                if (Array.isArray(fetchedData)) {
                    setData(fetchedData);
                    if (fetchedData.length > 0) {
                        // Establecer la descripción, componente y fuente solo una vez
                        setDescription(fetchedData[0].descripcion);
                        setComponente(fetchedData[0].nombre_componente);
                        setFuente(fetchedData[0].fuente);
                    }
                } else {
                    throw new Error('Fetched data is not an array');
                }
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const redterciaria = async () => {
        setLoading(true);
        try {
            const response = await red_terciaria(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                if (Array.isArray(fetchedData)) {
                    setRedData(fetchedData);
                } else {
                    throw new Error('Fetched data is not an array');
                }
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    // Columnas para la primera tabla (Categorización Vial)
    const columnsCategoriaVial = [
        { title: 'Código de Vía', dataIndex: 'codigo_via', key: 'codigo_via', className: 'filaP' },
        { title: 'Nombre de Vía', dataIndex: 'nombre_via', key: 'nombre_via', className: 'filaP' },
        { title: 'Longitud (KM)', dataIndex: 'longitud', key: 'longitud', className: 'filaP' },
    ];

    // Columnas para la segunda tabla (Red Terciaria)
    const columnsRedTerciaria = [
        { title: 'Código de Vía', dataIndex: 'codigo_via', key: 'codigo_via', className: 'filaP' },
        { title: 'Nombre de Vía', dataIndex: 'nombre_via', key: 'nombre_via', className: 'filaP' },
        { title: 'Longitud (KM)', dataIndex: 'longitud', key: 'longitud', className: 'filaP' },
        { title: 'Bueno', dataIndex: 'bueno', key: 'bueno', className: 'filaP' },
        { title: 'Regular', dataIndex: 'regular', key: 'regular', className: 'filaP' },
        { title: 'Malo', dataIndex: 'malo', key: 'malo', className: 'filaP' },
        { title: 'Total Longitud', dataIndex: 'total_long', key: 'total_long', className: 'filaP' },
        { title: 'Total Bueno', dataIndex: 'total_bueno', key: 'total_bueno', className: 'filaP' },
        { title: 'Total Regular', dataIndex: 'total_reg', key: 'total_reg', className: 'filaP' },
        { title: 'Total Malo', dataIndex: 'total_malo', key: 'total_malo', className: 'filaP' },
    ];

    return (
        <div className="page-content">
            {loading ? (
                <Spin size="large" />
            ) : data.length > 0 || redData.length > 0 ? (
                <>
                    {/* Mostrar la descripción solo una vez */}
                    <h3>Categorización Vial</h3>
                    <p className="descripcion">{description}</p>
                    <p className="descripcion">{componente}</p>

                    {/* Mostrar la primera tabla de Categorización Vial */}
                    <Table
                        columns={columnsCategoriaVial}
                        dataSource={data}  // Pasamos todos los datos de categorización vial a la tabla
                        rowKey="idcategorizacion"
                        pagination={false}
                    />

                    {/* Mostrar la segunda tabla de Red Terciaria */}
                    {redData.length > 0 && (
                        <>
                            <h3>Red Terciaria</h3>
                            <Table
                                columns={columnsRedTerciaria}
                                dataSource={redData}  // Pasamos los datos de red terciaria a la tabla
                                rowKey="id"
                                pagination={{ pageSize: 22 }}

                            />
                        </>
                    )}

                    <p className="descripcion">{fuente}</p>
                </>
            ) : (
                <p>No hay datos disponibles para este municipio.</p>
            )}
        </div>
    );
};

export default CategoriaVial;
